'use strict';

var  BpmnDebug = {};
//module.exports = BpmnDebug;
//export default BpmnDebug;




BpmnDebug.debugOn = true;
 BpmnDebug.log = function (...args) {
    if (BpmnDebug.debugOn) {
        //args.forEach(arg => console.log(arg));
        //console.log(...args);
    }
}
export var log = function (...args) {
    if (BpmnDebug.debugOn) {
        //args.forEach(arg => console.log(arg));
        //console.log(...args);
    }
}
